import { startCase } from 'lodash-es';
import { ProductTypeEnum } from '../../../../types';

export const getProductTypeFilterOptions = <T extends string>(options: T[], includePredictionMarkets: boolean): T[] =>
  includePredictionMarkets ? options : options.filter(option => option !== ProductTypeEnum.PredictionOutcome);

export const getProductTypeFilterOptionLabel = (option: string): string => {
  if (option === ProductTypeEnum.PredictionOutcome) {
    return 'Prediction';
  }
  if (option === ProductTypeEnum.OTC) {
    return 'OTC / Loan';
  }
  return startCase(option);
};
